import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { ThemeEnum } from 'ui/src/components/Theme';

import FooterSubscriptionForm, { type FooterSubscriptionFormProps } from './FooterSuscriptionForm';
import useFooterThemes from './themes';

export type SubscriptionFooterProps<Theme extends ThemeEnum = ThemeEnum> = {
  subscriptionApi: string;
  subscriptionBtn: FooterSubscriptionFormProps<Theme>['subscriptionBtn'];
  label?: string;
  placeholder?: string;
};

export default function SuscriptionFooter<Theme extends ThemeEnum = ThemeEnum>({
  subscriptionApi,
  subscriptionBtn,
  label,
  placeholder,
}: SubscriptionFooterProps<Theme>) {
  const { footerSubscriptionContainerClasses, footerSubscriptionTextClasses, footerSubsTextClasses } =
    useFooterThemes();

  return (
    <section className={twMerge(footerSubscriptionContainerClasses)}>
      <p className={twMerge(footerSubsTextClasses, footerSubscriptionTextClasses)}>
        Get insights from the experts on building and scaling technology teams.
      </p>
      <FooterSubscriptionForm<Theme>
        subscriptionApi={subscriptionApi}
        subscriptionBtn={subscriptionBtn}
        label={label}
        placeholder={placeholder}
      />
    </section>
  );
}
